import React from "react";
import { motion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

/**
 * Scroll-reveal wrapper with subtle fade + rise. Respects reduced motion.
 */
export const Reveal = ({ children, delay = 0, y = 20, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: easing, delay }}
    >
      {children}
    </MotionTag>
  );
};
